import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import packageInfo from '../../../../../../../package.json';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';
import {
    ApiServiceInterface,
    FormServiceInterface,
    OfflineQueue,
    OfflineServiceInterface,
    PushServiceInterface,
    ThemeServiceInterface,
    UserAccountInterface,
    UserServiceInterface,
} from '@hutsix/ngxh6';
import { ToastService } from '@hutsix/ngxh6';

/**
 * Top header for the logged-in app areas (CRM / My Profile / Debug). Kept separate
 * from the public <app-navbar> so the two menus can never bleed into each other -
 * this one has no public Home/Apply links, just the brand and the profile dropdown.
 */
@Component({
    selector: 'app-crm-navbar',
    templateUrl: './crm-navbar.component.html',
    styleUrls: ['./crm-navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CrmNavbarComponent {
    public env: string = environment.env;
    public version: string = packageInfo.version + (environment.env === 'staging' ? '-staging' : '');
    public _user: { loggedIn: boolean; account?: UserAccountInterface };
    public offlineQueue$: Observable<OfflineQueue[]>;

    constructor(
        public router: Router,
        public toastr: ToastService,
        @Inject('UserService') public userService: UserServiceInterface,
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('OfflineService') public offline: OfflineServiceInterface,
        @Inject('PushService') public push: PushServiceInterface,
        @Inject('ApiService') public api: ApiServiceInterface,
        @Inject('ThemeService') public themeService: ThemeServiceInterface,
        public cdRef: ChangeDetectorRef,
    ) {
        if (this._user) {
            this.offlineQueue$ = this.offline.getOfflineQueue();
        }
    }

    update(): void {
        if (this._user) {
            this.offlineQueue$ = this.offline.getOfflineQueue();
        }
    }

    clearCaches(): void {
        if (!confirm('All cached data will be removed. You will be required to re-sync to use offline capabilities. Are you sure?')) return;

        this.api.clearCaches().subscribe(res => {
            if (res) {
                this.toastr.success('Caches cleared!');
            } else {
                this.toastr.error('Try again.', 'Something went wrong.');
            }
        });
    }
}
